export default "__VITE_ASSET___5P8tfv_qMsMu6DX7YyMcA__"